document.addEventListener("DOMContentLoaded", function () {
  //----- SEARCH -----
    var search = document.querySelector('.main_header .search_icon');
    search.addEventListener('click', toggleSearch);
    function toggleSearch(e) {
      e.preventDefault();
      e.stopPropagation();
      var searchForm = document.querySelector('.main_header #search_box');
      if (searchForm.style.display === "block") {
        searchForm.style.display = "none"
      } else {
        searchForm.style.display = "block"
      }
    }
  //----- END OF SEARCH -----
  // ----- MENU -----
  if (window.screen.width < 800) {
    var menu = document.querySelector('.main_nav .show_menu');
    menu.addEventListener('click', toggleMenu);
    function toggleMenu() {
      var menuForm = document.querySelector('#nav_toggle');
      if (menuForm.style.display === "block") {
        menuForm.style.display = "none"
      } else {
        menuForm.style.display = "block"
      }
    }
    // ----- END OF MENU -----
    // ----- SUB_MENU -----
    var arrowIcon = document.querySelectorAll('.submenu_mobile_icn');
    arrowIcon.forEach(function(i) {
      i.addEventListener('click' , toggleSubmenu);
      function toggleSubmenu(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.parentNode.children[2].style.display === "block") {
          this.parentNode.children[2].style.display = "none";
        } else {
          this.parentNode.children[2].style.display = "block";
        }
      }
    });
    // ----- END OF SUB_MENU -----
  }
  //---- SHORT LINK ----
  var shortLink = document.querySelector(".short_link");
  if (shortLink) {
    shortLink.addEventListener("click", function (event) {
      event.preventDefault();
      var $temp = document.createElement("input");
      document.body.appendChild($temp);
      $temp.value = shortLink.href;
      $temp.select();
      document.execCommand("copy");
      $temp.remove();
      document.querySelector(".tinyurl_copied").style.display = "block";
      setTimeout(function () {
        document.querySelector(".tinyurl_copied").style.display = "none";
      }, 3000);
    });
  }
  //---- END OF SHORT LINK ----
  //---- RATE NEWS ----
  document.getElementById("plusme").addEventListener("click", function () {
    fetch(
      "/rates/score/?type=%2B&object_master_id=" + newsMasterIdForRate
    ).then(function (response) {
      if (response.status == 200) {
        response.json().then(function (newScore) {
          // console.log(newScore);
          var plusmeElement = document.getElementById("plusme");
          plusmeElement.innerHTML ="<span id='cityscoree'>" + newScore.plus +"</span>" + "<svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' preserveAspectRatio='xMidYMid meet' viewBox='0 0 24 24'><path fill='currentColor' d='M20 8h-5.612l1.123-3.367c.202-.608.1-1.282-.275-1.802S14.253 2 13.612 2H12c-.297 0-.578.132-.769.36L6.531 8H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h13.307a2.01 2.01 0 0 0 1.873-1.298l2.757-7.351A1 1 0 0 0 22 12v-2c0-1.103-.897-2-2-2zM4 10h2v9H4v-9zm16 1.819L17.307 19H8V9.362L12.468 4h1.146l-1.562 4.683A.998.998 0 0 0 13 10h7v1.819z'/></svg>"
        });
      } 
    });
  });
  //---- END OF RATE NEWS ----
  //---- TABLE ----
  if (document.querySelector("#echo_detail")) {
    var tables = document.querySelectorAll("#echo_detail table");
    tables.forEach(function (table) {
      var parentTable = document.createElement('div');
      parentTable.classList.add("table_res");
      table.parentNode.replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }
  //---- END OF TABLE ----
  //---- GALLERY ATTACH ----
  if (document.getElementById('gallery_attach')) {
    new Splide('#gallery_attach', {
      autoplay: true,
      interval: 4000,
      type   : 'loop',
      direction: 'rtl',
      adaptiveHeight: false,
    }).mount();
  }
  //---- END OF GALLERY ATTACH ----
  //---- GALLERY TWIG ----
  if (document.getElementById('middle_gallery')) {
    new Splide('#middle_gallery', {
      autoplay: true,
      interval: 4000,
      type   : 'loop',
      direction: 'rtl',
      adaptiveHeight: false,
    }).mount();
  }
  //---- END OF GALLERY TWIG ----
  // ----- INLINE BOXS & ADV -----
  var countP = document.querySelectorAll('#echo_detail p:not(table p, blockquote p)');
  function insertBefore(newNode, dist) {
    dist.parentNode.insertBefore(newNode, dist)
  }
  // *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*- //
  if (document.getElementById('inline_adv')) {
    if (countP.length > 0) {
      var adv = document.getElementById('inline_adv');
      insertBefore(adv, countP[0].nextSibling);
    } else {
      document.getElementById('inline_adv').style.display = "none";
    }
  } 
  if (document.getElementById('inline_adv1')) {
    if (countP.length > 3) {
      var adv = document.getElementById('inline_adv1');
      insertBefore(adv, countP[3]);
    } else {
      document.getElementById('inline_adv1').style.display = "none";
    }
  } 
  if (document.getElementById('inline_adv2')) {
    if (countP.length > 5) {
      var adv = document.getElementById('inline_adv2');
      insertBefore(adv, countP[5]);
    } else {
      document.getElementById('inline_adv2').style.display = "none";
    }
  } 
  //---------- END OF INLINE BOX & ADV ----------
});